// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2FjJe","list":"styles_list__30e3y"};